export default __webpack_public_path__ + "static/media/cover_carta.b5a4f74a.png";